import { PhotoIcon, RectangleStackIcon } from "@heroicons/react/24/outline";
import { useState } from "react";
import { formatPrice } from "@/utils/wizardPriceUtils";
import PriceDisplay from "@/components/wizard/PriceDisplay";
import OptionCard from "@/components/wizard/OptionCard";
import WizardNavigation from "../WizardNavigation";
import StepHeader from "../StepHeader";

export default function StepFlatrate({ value, onNext, onBack, prices }) {
  const [selectedValue, setSelectedValue] = useState(value);

  if (!prices) {
    return (
      <div className="text-center py-8">
        <p className="text-slate-600">Preise werden geladen...</p>
      </div>
    );
  }

  const handleSelect = (flatrateOption) => {
    setSelectedValue(flatrateOption === "with");
  };

  const handleNext = () => {
    if (selectedValue !== null) {
      onNext({ wantsFlatrate: selectedValue });
    }
  };

  return (
    <div className="space-y-6">
      <StepHeader
        title="Möchtest du eine Fotodruck-Flatrate?"
        description="Mit einer Flatrate sind alle Ausdrucke im Paket enthalten."
      />

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <OptionCard
          isSelected={selectedValue === false}
          onClick={() => handleSelect("without")}
          icon={PhotoIcon}
          label="Ohne Flatrate"
          description="Günstiger Einstieg mit begrenzten Ausdrucken."
        />
        <OptionCard
          isSelected={selectedValue === true}
          onClick={() => handleSelect("with")}
          icon={RectangleStackIcon}
          label="Mit Flatrate"
          badge="Am beliebtesten"
          description="Deine Gäste können so viele Fotos drucken, wie sie möchten."
        />
      </div>

      <WizardNavigation
        onBack={onBack}
        onNext={handleNext}
        disableNext={selectedValue === null}
      />
    </div>
  );
}
